import { managePayments, upgradeAccount } from "@/services/subscription.service";

const state = {
    loading: false,
    error: null
};

const mutations = {
    SET_IS_LOADING(state, isLoading) {
        state.loading = isLoading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    }
};

const actions = {
    async managePaymentsAction({ commit, dispatch }) {
        commit("SET_IS_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await managePayments();
            if (response.url) {
                window.location.href = response.url;
            } else {
                commit("SET_ERROR", response.message);
            }
            dispatch("analytics/trackEvent", { event: 'manage_payments_clicked' }, { root: true });
        } catch (error) {
            commit("SET_ERROR", error.message);
            dispatch("analytics/trackEvent", { 
                event: 'manage_payments_failed',
                properties: { error: error.message }
            }, { root: true });
        } finally {
            commit("SET_IS_LOADING", false);
        }
    },

    async upgradeAccountAction({ commit, dispatch }) {
        commit("SET_IS_LOADING", true);
        commit("SET_ERROR", null);
        try {
            const response = await upgradeAccount();
            if (response.url) {
                window.location.href = response.url;
            } else {
                commit("SET_ERROR", response.message);
            }
            dispatch("analytics/trackEvent", { event: 'upgrade_success' }, { root: true });
        } catch (error) {
            commit("SET_ERROR", error.message);
            dispatch("analytics/trackEvent", { 
                event: 'upgrade_failed',
                properties: { error: error.message }
            }, { root: true });
        } finally {
            commit("SET_IS_LOADING", false);
        }
    },

    /**
     * Clears all subscription-related state
     * Used during logout or session end
     */
    clearSubscriptionState({ commit }) {
        console.log('💳 Clearing subscription state...');
        
        commit("SET_IS_LOADING", false);
        commit("SET_ERROR", null);
        
        console.log('✅ Subscription state cleared');
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}; 